// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Z-uN","col":"styles_col__2KKuE"};